import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/**
 * Wrapper okolo admin stránek — pokud uživatel není v roli Admin, redirect na /app.
 * Backend validuje role nezávisle (defense in depth) — tohle je jen UX guard.
 */
export default function RequireAdmin({ children }: { children: JSX.Element }) {
  const user = useAuthStore((s) => s.user);
  const isAdmin = user?.roles?.includes('Admin') ?? false;
  if (!user) return <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 opacity-60 animate-pulse">…</div>;
  return isAdmin ? children : <Navigate to="/app" replace />;
}
